<template>
    <overlay-modal ref="overlayModal" width="65%">
        <template v-slot:header>
            <div class="d-md-flex justify-content-between">
                <div class="position-relative" style="top: 10px;">
                    <RatingStars class="position-absolute" style="top: -15px"  :value="rating" />
                    <h4 class="cursive">{{name}}</h4>
                </div>
                <div>
                    <button v-if="!isSelected" class="mt-2 mt-md-0 btn btn-primary nowrap" @click="onSelect">
                        Aggiungi ad itinerario
                    </button>
                    <button v-else :disabled="!change" class="mt-2 mt-md-0 btn btn-primary nowrap" @click="onSelect">
                        Conferma modifiche
                    </button>
                </div>
            </div>
        </template>
        <template>
            <div class="modal-hotel-detail">
                <div>
                    <big-carousel v-if="images.length>0" :images="images" class="mb-3"/>
                    <tabs class="mb-3">
                        <tab width="25%" title="Seleziona le camere">
                            <div v-for="(group, index) in groups" :key="index" class="mb-3">
                                <h4>Camera {{index+1}}</h4>
                                <div class="d-flex mb-2">
                                    <img src="../../../../../assets/images/svg/black/icone_passeggeri.svg" height="18px" class="mr-2"/>
                                    <span class="d-block">{{cameraTextFromIndex(index)}}</span>
                                </div>
                                <room-detail v-for="(item, index2) in group.rooms" :key="index2" :value="item" :group="group" @change="onChangeRoomSelected"/>
                            </div>
                        </tab>
                        <tab width="25%" title="Descrizione" @click="onSelectTabDescrizione">
                            <div>
                                <p class="text-justify" v-html="toBrTag(description)"></p>
                            </div>
                        </tab>
                        <tab width="25%" title="Caratteristiche">
                            <div v-for="(item, index) in infos" :key="index">
                                <h4>{{item.title}}</h4>
                                <table class="table table-striped">
                                    <tbody>
                                    <tr v-for="(section, index) in item.paragraphs" :key="index" :value="section">
                                        <td style="width:30%">
                                            <b>{{section.title}}</b>
                                        </td>
                                        <td style="width:70%">
                                            <p class="m-0" v-for="(text, index) in section.texts" :key="index" :value="text">{{text}}</p>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </tab>
                        <tab width="25%" title="Mappa">
                            <CustomGoogleMap :markers="markers"/>
                        </tab>
                    </tabs>
                </div>
            </div>
        </template>
    </overlay-modal>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import OverlayModal from '../../../../modals/OverlayModal'
import CarouselOne from '../../../common/CarouselOne'
import {cameraText, hotelName, toBrTag} from '../../../../../utils/helper'
import CustomGoogleMap from '../../../common/CustomGoogleMap'
import RoomDetail from '../hotel-panel/RoomDetail'
import BigCarousel from '../../../common/BigCarousel'
import RatingStars from '../../../../common/RatingStars'
import AnalyticEvents from '../../../../common/AnalyticEvents'
import HotelActions from '../../../../actions/HotelAction'
export default {
  name: 'ModalHotelDetail',
  mixins: [AnalyticEvents, HotelActions],
  components: {RatingStars, BigCarousel, RoomDetail, CustomGoogleMap, CarouselOne, OverlayModal},
  props: {
    value: {
      type: Object,
      default: () => { return {hotel: {}, groups: []} }
    }
  },
  data: function () {
    return {
      images: [],
      change: false
    }
  },
  computed: {
    isSelected () {
      if (!this.value) return false
      return this.getSelectedHotels().some(item => this.name === (hotelName(item.hotel.location.name)))
    },
    info () {
      return this.value ? this.value : {hotel: {}, groups: []}
    },
    name () {
      const {location} = this.info.hotel
      return location && hotelName(location.name)
    },
    rating () {
      const {summary} = this.info.hotel
      return summary && 1 * summary.rate.split('R')[1]
    },
    description () {
      const {summary, extra} = this.info.hotel
      if (extra && extra.description) return extra.description
      if (summary && summary.description) return summary.description
      return ''
    },
    infos () {
      const { detail } = this.info.hotel
      return detail ? detail.info : ''
    },
    markers () {
      const {location} = this.info.hotel
      if (!location) return []
      const {latitude, longitude} = location
      return [{title: this.name, lat: latitude, lng: longitude}]
    },
    groups () {
      return this.info.groups
    }
  },
  methods: {
    ...mapActions(['updateSummary']),
    ...mapGetters(['getSearch', 'getSelectedHotels']),
    toBrTag,
    makeImages () {
      const { extra, detail, summary } = this.info.hotel
      if (extra && extra.images.length > 0) {
        this.images = extra.images
        return
      }
      if (detail && detail.images.length > 0) {
        this.images = detail.images.map(item => { return item.objA })
        return
      }
      this.images = summary ? [{objA: summary.imageUrl, objB: summary.thumbnailUrl}] : []
    },
    open () {
      this.makeImages()
      this.$refs.overlayModal.open()
    },
    close () {
      this.trackModalDettaglioHotelChiudi()
      this.$refs.overlayModal.close()
    },
    cameraTextFromIndex (index) {
      const camera = this.getSearch().camere[index]
      return camera ? cameraText(camera) : ''
    },
    onSelect () {
      this.addHotelAction(this.value)
      this.$emit('select', this.value)
      this.updateSummary()
      this.close()
    },
    onSelectTabDescrizione () {
      this.trackModalDettaglioHotelTabDescrizione()
    },
    onChangeRoomSelected: function () {
      this.trackModalDettaglioHotelCambia()
      this.change = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/volo-hotel/modals/ModalHotelDetail.vue